/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ComponentAxle } from './ComponentAxle';
import type { MotorState } from './MotorState';
/**
 * Configuration that can change characteristics of the motor.
 */
export type MotorConfiguration = {
    component_config_type?: MotorConfiguration.component_config_type;
    axle?: ComponentAxle;
    state?: MotorState;
};
export namespace MotorConfiguration {
    export enum component_config_type {
        MOTOR = 'motor',
    }
}

